
export default {
  name: 'Sort',

  props: {
    active: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [
        { id: 'default', type: 'string', value: 'По умолчанию' },
        { id: 'price', type: 'string', value: 'Стоимость (Дешевле)' },
        { id: '-price', type: 'string', value: 'Стоимость (Дорогие)' },
        { id: '-created_at', type: 'string', value: 'Сначала новые' },
      ],
    },
  },

  computed: {
    getActiveSort: function () {
      return (this.options || []).find((t) => t.id === (this.active || 'default'))?.id;
    },
  },
};
